var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"languages"},_vm._l((_vm.languages),function(ref){
var code = ref.code;
var label = ref.label;
return _c('a-button',{key:code,attrs:{"disabled":_vm.$i18n.locale === code,"type":"link"},on:{"click":function($event){return _vm.updateLanguage(code)}}},[_vm._v(" "+_vm._s(label)+" ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }